import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-slate-950 pt-20 pb-16" data-id="element-95">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black opacity-80" data-id="element-96" />
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-97" />

      {/* Glow Orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-600/20 rounded-full blur-[100px]" data-id="element-98" />
      <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-red-600/20 rounded-full blur-[100px]" data-id="element-99" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-100">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-101">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left space-y-8" data-id="element-102">
            <div className="inline-block px-4 py-1 bg-red-900/30 border border-red-500/30 rounded text-red-400 font-bold tracking-widest text-sm uppercase mb-4" data-id="element-103">
              Guía Definitiva 2026
            </div>

            <h1 className="text-5xl md:text-7xl font-black text-white leading-tight italic" data-id="element-104">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400" data-id="element-105">
                DOMINIO TOTAL
              </span>
              <br data-id="element-106" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500 text-glow" data-id="element-107">
                EN FREE FIRE
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 font-medium max-w-2xl mx-auto lg:mx-0 border-l-4 border-blue-500 pl-6" data-id="element-108">
              Deja de perder. Empieza a dominar en{' '}
              <span className="text-white font-bold" data-id="element-109">7 días</span>.
            </p>

            <p className="text-lg text-slate-400 max-w-xl mx-auto lg:mx-0" data-id="element-110">
              El sistema paso a paso para jugar con más inteligencia, más
              control y más ventaja que el 90% de los jugadores que solo entran
              a disparar sin pensar.
            </p>

            <div className="pt-4" data-id="element-111">
              <CTAButton subtext="Acceso inmediato • Método claro • Sin trucos falsos" onClick={() => {
              document.getElementById('comprar')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-112">
                QUIERO VENTAJA REAL AHORA
              </CTAButton>
            </div>
          </div>

          {/* Image Content */}
          <div className="flex-1 relative group" data-id="element-113">
            <div className="absolute inset-0 bg-gradient-to-tr from-red-500 to-blue-500 rounded-xl blur-2xl opacity-20 group-hover:opacity-30 transition-opacity duration-500" data-id="element-114" />
            <img src="https://cdn.magicpatterns.com/uploads/ha9VoeZWQ9h4Kj1MjUgYJ6/WhatsApp_Image_2026-02-12_at_9.10.25_AM.jpg" alt="Dominio Total en Free Fire Ebook Cover" className="relative w-full max-w-md mx-auto transform rotate-3 hover:rotate-0 transition-transform duration-500 drop-shadow-2xl z-10" data-id="element-115" />
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-slate-950 to-transparent" data-id="element-116" />
    </section>;
}